"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryParam = void 0;
function getQueryParam(url, param) {
  const sanitizedParam = param.replace(/[[]/, "[").replace(/[]]/, "]");
  const regexS = "[?&]" + sanitizedParam + "=([^&#]*)";
  const regex = new RegExp(regexS);
  const results = regex.exec(url);
  const paramValue = results ? results[1] : "";
  try {
    // if decodeURIComponent receives a string with an wrongly encoded value it will crash
    return decodeURIComponent(paramValue).replace(/\W/gi, " ");
  } catch (e) {
    return null;
  }
}
exports.getQueryParam = getQueryParam;